<template>
  <a class="button is-primary is-fullwidth login-button-primary"
     :class="{ 'is-loading': loading }"
     :disabled="disabled"
     :href="href"
     @click="clicked">
    {{ text }}
  </a>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .login-button-primary
    border-radius: login-radius
    height: login-control-height
    font-size: siz(12)
    background-color: #FF583B !important
    &.button.is-loading:after
      width: siz(16)
      height: siz(16)
      border-width: siz(2)
      margin-left: siz(-8)
      margin-top: siz(-8)
</style>

<script>
  export default {
    props: {
      text: String,
      href: String,
      loading: Boolean,
      disabled: Boolean
    },
    methods: {
      clicked (e) {
        if (!this.loading && !this.disabled) {
          this.$emit('click', e)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ButtonPrimary.vue?020fe1ee